var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.92,118.43H359.34s9.48-25.88,24.06-25.88,19.16,17.86,19.16,17.86,9.84-9.71,17.92-9.71,15.11,12.83,15.11,12.83S447,106.63,454.92,118.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.47,85H304.8s10-14.46,17.85-14.46,10.18,9.64,10.18,9.64,5.55-4.5,10.69-3.69S349.47,85,349.47,85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.08,156.88h-87S57,130.28,69.74,128.62s18.84,19.76,18.84,19.76,8.22-7.57,14.69-7.57,11.45,10,11.45,10S127.65,144,132.08,156.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.38,63.55H139.62s10.09-19.28,21-19.56,16.71,14.59,16.71,14.59S194.41,44.91,198.38,63.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.08,179.14H215.41s6.82-13,14.21-13.2,11.28,9.84,11.28,9.84S252.4,166.56,255.08,179.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.13,
    y: 216.85,
    width: 105.78,
    height: 118.24,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.69,
    y: 209.68,
    width: 110.66,
    height: 7.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.14,
    y: 286.81,
    width: 51.78,
    height: 7.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.39,
    y: 233.98,
    width: 17.96,
    height: 27.84,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.24,
    y: 236.02,
    width: 14.26,
    height: 23.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.82,
    y: 261.83,
    width: 23.11,
    height: 4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "226.5 236.03 226.5 238.96 212.24 253.23 212.24 247.8 224.02 236.03 226.5 236.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.5 253.64 226.5 256.36 223.07 259.79 220.36 259.79 226.5 253.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.04 236.03 212.24 240.83 212.24 238.12 214.32 236.03 217.04 236.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.5 249.39 226.5 250.26 216.97 259.79 216.1 259.79 226.5 249.39",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 210.39,
    y: 250,
    width: 17.96,
    height: 2.04,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.04,
    y: 233.98,
    width: 17.96,
    height: 27.84,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.89,
    y: 236.02,
    width: 14.26,
    height: 23.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.47,
    y: 261.83,
    width: 23.11,
    height: 4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "257.16 236.03 257.16 238.96 242.89 253.23 242.89 247.8 254.67 236.03 257.16 236.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.16 253.64 257.16 256.36 253.72 259.79 251.01 259.79 257.16 253.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.69 236.03 242.89 240.83 242.89 238.12 244.97 236.03 247.69 236.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.16 249.39 257.16 250.26 247.63 259.79 246.75 259.79 257.16 249.39",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 241.04,
    y: 250,
    width: 17.96,
    height: 2.04,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.69,
    y: 233.98,
    width: 17.96,
    height: 27.84,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.55,
    y: 236.02,
    width: 14.26,
    height: 23.77,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.12,
    y: 261.83,
    width: 23.11,
    height: 4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "287.81 236.03 287.81 238.96 273.54 253.23 273.54 247.8 285.32 236.03 287.81 236.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.81 253.64 287.81 256.36 284.38 259.79 281.66 259.79 287.81 253.64",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.35 236.03 273.54 240.83 273.54 238.12 275.63 236.03 278.35 236.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.81 249.39 287.81 250.26 278.28 259.79 277.41 259.79 287.81 249.39",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.69,
    y: 250,
    width: 17.96,
    height: 2.04,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.03,
    y: 293.99,
    width: 43.99,
    height: 41.1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.99,
    y: 297.03,
    width: 38.07,
    height: 38.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "269.06 312.91 269.06 319.99 253.95 335.09 246.88 335.09 269.06 312.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.93 297.03 230.99 306.97 230.99 299.89 233.86 297.03 240.93 297.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.17 297.03 230.99 328.21 230.99 324.68 258.64 297.03 262.17 297.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.06 323.65 269.06 327.19 261.15 335.09 257.62 335.09 269.06 323.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.06 300.56 269.06 301.21 235.18 335.09 234.52 335.09 269.06 300.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.05 297.03 230.99 311.08 230.99 310.43 244.39 297.03 245.05 297.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 297.03 230.99 323.07 230.99 322.41 256.38 297.03 257.04 297.03",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 248.8,
    y: 297.03,
    width: 2.45,
    height: 38.07,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.47,
    y: 240.67,
    width: 89.66,
    height: 94.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.11 240.67 197.13 240.67 197.13 335.09 193.58 335.09 189.11 240.67",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.65,
    y: 253.64,
    width: 15.71,
    height: 24.34,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.27,
    y: 255.43,
    width: 12.47,
    height: 20.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.4,
    y: 277.99,
    width: 20.2,
    height: 3.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.74 255.43 131.74 258 119.27 270.47 119.27 265.73 129.56 255.43 131.74 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.74 270.83 131.74 273.2 128.74 276.21 126.36 276.21 131.74 270.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.47 255.43 119.27 259.63 119.27 257.25 121.09 255.43 123.47 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.74 267.11 131.74 267.88 123.41 276.21 122.64 276.21 131.74 267.11",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.65,
    y: 267.65,
    width: 15.71,
    height: 1.78,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.45,
    y: 253.64,
    width: 15.71,
    height: 24.34,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.07,
    y: 255.43,
    width: 12.47,
    height: 20.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.2,
    y: 277.99,
    width: 20.2,
    height: 3.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "158.54 255.43 158.54 258 146.06 270.47 146.06 265.73 156.36 255.43 158.54 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.54 270.83 158.54 273.2 155.53 276.21 153.16 276.21 158.54 270.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.26 255.43 146.06 259.63 146.06 257.25 147.89 255.43 150.26 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.54 267.11 158.54 267.88 150.21 276.21 149.44 276.21 158.54 267.11",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 144.45,
    y: 267.65,
    width: 15.71,
    height: 1.78,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.25,
    y: 253.64,
    width: 15.71,
    height: 24.34,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.87,
    y: 255.43,
    width: 12.47,
    height: 20.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 277.99,
    width: 20.2,
    height: 3.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "185.34 255.43 185.34 258 172.87 270.47 172.87 265.73 183.16 255.43 185.34 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.34 270.83 185.34 273.2 182.34 276.21 179.96 276.21 185.34 270.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.06 255.43 172.87 259.63 172.87 257.25 174.69 255.43 177.06 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.34 267.11 185.34 267.88 177.01 276.21 176.24 276.21 185.34 267.11",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 171.25,
    y: 267.65,
    width: 15.71,
    height: 1.78,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.65,
    y: 290.4,
    width: 15.71,
    height: 24.34,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.27,
    y: 292.19,
    width: 12.47,
    height: 20.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.4,
    y: 314.75,
    width: 20.2,
    height: 3.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.74 292.19 131.74 294.76 119.27 307.23 119.27 302.49 129.56 292.19 131.74 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.74 307.59 131.74 309.96 128.74 312.97 126.36 312.97 131.74 307.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.47 292.19 119.27 296.39 119.27 294.01 121.09 292.19 123.47 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.74 303.87 131.74 304.63 123.41 312.97 122.64 312.97 131.74 303.87",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.65,
    y: 304.41,
    width: 15.71,
    height: 1.78,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.45,
    y: 290.4,
    width: 15.71,
    height: 24.34,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.07,
    y: 292.19,
    width: 12.47,
    height: 20.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.2,
    y: 314.75,
    width: 20.2,
    height: 3.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "158.54 292.19 158.54 294.76 146.06 307.23 146.06 302.49 156.36 292.19 158.54 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.54 307.59 158.54 309.96 155.53 312.97 153.16 312.97 158.54 307.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.26 292.19 146.06 296.39 146.06 294.01 147.89 292.19 150.26 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.54 303.87 158.54 304.63 150.21 312.97 149.44 312.97 158.54 303.87",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 144.45,
    y: 304.41,
    width: 15.71,
    height: 1.78,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.25,
    y: 290.4,
    width: 15.71,
    height: 24.34,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.87,
    y: 292.19,
    width: 12.47,
    height: 20.78,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 314.75,
    width: 20.2,
    height: 3.5,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "185.34 292.19 185.34 294.76 172.87 307.23 172.87 302.49 183.16 292.19 185.34 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.34 307.59 185.34 309.96 182.34 312.97 179.96 312.97 185.34 307.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.06 292.19 172.87 296.39 172.87 294.01 174.69 292.19 177.06 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.34 303.87 185.34 304.63 177.01 312.97 176.24 312.97 185.34 303.87",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 171.25,
    y: 304.41,
    width: 15.71,
    height: 1.78,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.41,
    y: 233.49,
    width: 92.72,
    height: 7.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.87,
    y: 240.67,
    width: 89.66,
    height: 94.42,
    transform: "translate(695.4 575.76) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.89 240.67 302.87 240.67 302.87 335.09 306.42 335.09 310.89 240.67",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.64,
    y: 253.64,
    width: 15.71,
    height: 24.34,
    transform: "translate(749 531.63) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.26,
    y: 255.43,
    width: 12.47,
    height: 20.78,
    transform: "translate(749 531.63) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.4,
    y: 277.99,
    width: 20.2,
    height: 3.5,
    transform: "translate(749 559.48) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 255.43 368.26 258 380.74 270.47 380.74 265.73 370.44 255.43 368.26 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 270.83 368.26 273.2 371.26 276.21 373.64 276.21 368.26 270.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.54 255.43 380.74 259.63 380.74 257.25 378.91 255.43 376.54 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 267.11 368.26 267.88 376.59 276.21 377.36 276.21 368.26 267.11",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 366.64,
    y: 267.65,
    width: 15.71,
    height: 1.78,
    transform: "translate(749 537.08) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.84,
    y: 253.64,
    width: 15.71,
    height: 24.34,
    transform: "translate(695.4 531.63) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.46,
    y: 255.43,
    width: 12.47,
    height: 20.78,
    transform: "translate(695.4 531.63) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.6,
    y: 277.99,
    width: 20.2,
    height: 3.5,
    transform: "translate(695.4 559.48) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "341.46 255.43 341.46 258 353.94 270.47 353.94 265.73 343.64 255.43 341.46 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.46 270.83 341.46 273.2 344.46 276.21 346.84 276.21 341.46 270.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.74 255.43 353.94 259.63 353.94 257.25 352.11 255.43 349.74 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.46 267.11 341.46 267.88 349.79 276.21 350.56 276.21 341.46 267.11",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 339.84,
    y: 267.65,
    width: 15.71,
    height: 1.78,
    transform: "translate(695.4 537.08) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.05,
    y: 253.64,
    width: 15.71,
    height: 24.34,
    transform: "translate(641.8 531.63) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.66,
    y: 255.43,
    width: 12.47,
    height: 20.78,
    transform: "translate(641.8 531.63) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.8,
    y: 277.99,
    width: 20.2,
    height: 3.5,
    transform: "translate(641.8 559.48) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "314.66 255.43 314.66 258 327.13 270.47 327.13 265.73 316.84 255.43 314.66 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.66 270.83 314.66 273.2 317.67 276.21 320.04 276.21 314.66 270.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.94 255.43 327.13 259.63 327.13 257.25 325.31 255.43 322.94 255.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.66 267.11 314.66 267.88 322.99 276.21 323.76 276.21 314.66 267.11",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 313.05,
    y: 267.65,
    width: 15.71,
    height: 1.78,
    transform: "translate(641.8 537.08) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.64,
    y: 290.4,
    width: 15.71,
    height: 24.34,
    transform: "translate(749 605.15) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.26,
    y: 292.19,
    width: 12.47,
    height: 20.78,
    transform: "translate(749 605.15) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.4,
    y: 314.75,
    width: 20.2,
    height: 3.5,
    transform: "translate(749 633) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 292.19 368.26 294.76 380.74 307.23 380.74 302.49 370.44 292.19 368.26 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 307.59 368.26 309.96 371.26 312.97 373.64 312.97 368.26 307.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.54 292.19 380.74 296.39 380.74 294.01 378.91 292.19 376.54 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 303.87 368.26 304.63 376.59 312.97 377.36 312.97 368.26 303.87",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 366.64,
    y: 304.41,
    width: 15.71,
    height: 1.78,
    transform: "translate(749 610.6) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.84,
    y: 290.4,
    width: 15.71,
    height: 24.34,
    transform: "translate(695.4 605.15) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.46,
    y: 292.19,
    width: 12.47,
    height: 20.78,
    transform: "translate(695.4 605.15) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.6,
    y: 314.75,
    width: 20.2,
    height: 3.5,
    transform: "translate(695.4 633) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "341.46 292.19 341.46 294.76 353.94 307.23 353.94 302.49 343.64 292.19 341.46 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.46 307.59 341.46 309.96 344.46 312.97 346.84 312.97 341.46 307.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.74 292.19 353.94 296.39 353.94 294.01 352.11 292.19 349.74 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.46 303.87 341.46 304.63 349.79 312.97 350.56 312.97 341.46 303.87",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 339.84,
    y: 304.41,
    width: 15.71,
    height: 1.78,
    transform: "translate(695.4 610.6) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.05,
    y: 290.4,
    width: 15.71,
    height: 24.34,
    transform: "translate(641.8 605.15) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.66,
    y: 292.19,
    width: 12.47,
    height: 20.78,
    transform: "translate(641.8 605.15) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.8,
    y: 314.75,
    width: 20.2,
    height: 3.5,
    transform: "translate(641.8 633) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "314.66 292.19 314.66 294.76 327.13 307.23 327.13 302.49 316.84 292.19 314.66 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.66 307.59 314.66 309.96 317.67 312.97 320.04 312.97 314.66 307.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.94 292.19 327.13 296.39 327.13 294.01 325.31 292.19 322.94 292.19",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.66 303.87 314.66 304.63 322.99 312.97 323.76 312.97 314.66 303.87",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 313.05,
    y: 304.41,
    width: 15.71,
    height: 1.78,
    transform: "translate(641.8 610.6) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.87,
    y: 233.49,
    width: 92.72,
    height: 7.18,
    transform: "translate(698.45 474.16) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.43,201.18v8.49H213.62v-8.49h12.89s6.29-9.67,23.51-9.67,23.53,9.67,23.53,9.67Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 453.43,
    rx: 188.03,
    ry: 16.8,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "34.56 342.61 88.42 342.37 142.28 342.28 250 342.11 357.72 342.28 411.58 342.37 465.44 342.61 411.58 342.85 357.72 342.94 250 343.11 142.28 342.94 88.42 342.85 34.56 342.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.36,
    y: 335.11,
    width: 417.27,
    height: 7.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.62,335.11a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.64A12.28,12.28,0,0,1,70.62,335.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,335.11a12.28,12.28,0,0,1,.5,3.63,12,12,0,0,1-.5,3.64,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.85,335.11a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.64A12.28,12.28,0,0,1,135.85,335.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,335.11a12.28,12.28,0,0,1,.5,3.63,12,12,0,0,1-.5,3.64,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.08,335.11a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.64A12.28,12.28,0,0,1,201.08,335.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.69,335.11a12.28,12.28,0,0,1,.5,3.63,12,12,0,0,1-.5,3.64,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.31,335.11a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.64A12.28,12.28,0,0,1,266.31,335.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.92,335.11a12.28,12.28,0,0,1,.5,3.63,12,12,0,0,1-.5,3.64,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,335.11a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.64A12.28,12.28,0,0,1,331.54,335.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.15,335.11a12.28,12.28,0,0,1,.5,3.63,12,12,0,0,1-.5,3.64,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.77,335.11a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.64A12.28,12.28,0,0,1,396.77,335.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.38,335.11a12.28,12.28,0,0,1,.5,3.63,12,12,0,0,1-.5,3.64,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.42,335.11s-.84-3.93-2.52-4.53-2.71,1.15-2.71,1.15-.39-3.75-2.78-4.87S76.24,328,76.24,328s-1.83-4.76-5.1-4.76-4.91,7-4.91,7-1.93-2.08-3.91-.9-2,5.77-2,5.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.26,335.11s-.84-3.93-2.52-4.53-2.7,1.15-2.7,1.15-.4-3.75-2.78-4.87-4.17,1.17-4.17,1.17-1.83-4.76-5.1-4.76-4.92,7-4.92,7-1.92-2.08-3.9-.9-2,5.77-2,5.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,335.11H133.15s1-4.17,2.93-4.46a2.89,2.89,0,0,1,2.88,1.63s-.09-5.81,3.57-6.8,6.72,4.15,6.72,4.15,2.3-2.93,5.42-2.74,3.93,5,3.93,5S161.44,330.23,162.7,335.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.16,335.11H46.61s0-2.32,1.56-2.93a2.08,2.08,0,0,1,2.44.58s.62-4.25,3.47-4.25,4.22,3.67,4.22,3.67a2.18,2.18,0,0,1,2.22-.9C62.1,331.48,62.16,335.11,62.16,335.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9,335.11H159.35s0-2.32,1.56-2.93a2.08,2.08,0,0,1,2.44.58s.63-4.25,3.48-4.25,4.21,3.67,4.21,3.67a2.18,2.18,0,0,1,2.22-.9C174.84,331.48,174.9,335.11,174.9,335.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.7,335.11H415.15s0-2.32,1.56-2.93a2.08,2.08,0,0,1,2.44.58s.62-4.25,3.47-4.25,4.22,3.67,4.22,3.67a2.17,2.17,0,0,1,2.22-.9C430.64,331.48,430.7,335.11,430.7,335.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.39,335.11H427.75s.06-3.82,2.58-4.83a3.44,3.44,0,0,1,4,1s1-7,5.73-7,6.94,6,6.94,6a3.6,3.6,0,0,1,3.66-1.49C453.29,329.13,453.39,335.11,453.39,335.11Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.81,333s20.31,33.77,20.32,33.8c3.92,6.43,7.24,12.15,8.68,15.26,0,0,0,0,0,0a5.28,5.28,0,0,1,.74,2.28s0,.05,0,.06c-1.12,2.47-51.65,35.27-53.8,35.82s-3.89-5.53-2.94-8.37,14.68-24.05,14.68-24.05l-20-33.95Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.07,356.76l-33.62,19.17s-29.1-41.29-34.93-66.22c-4.15-17.74,32.93-100.36,32.93-100.36l35.28,1.38s-31.68,80-30,88.26C294.78,309.08,323.07,356.76,323.07,356.76Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.56,384.43s0,.05,0,.06c-1.13,2.47-51.66,35.27-53.8,35.82s-3.89-5.53-2.94-8.37c.52-1.54,4.75-8.42,8.54-14.43-3.52,5.84-10.81,22.9,42.48-24.5,2.24,3.81,4,7,5,9.09,0,0,0,0,0,0A5.2,5.2,0,0,1,338.56,384.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.86,270l24.07-25.48c5.53-5.13,13.4-13,14.8-13.11,2.63.61,45.5,43.91,46.47,45.91s-4.64,4.91-7.61,4.55-26.5-9.58-26.5-9.58l-25.43,25.34Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.59,281.91c-1.5-.19-8.12-2.58-14.38-4.93,7.23,1.38,21.28,1.19-38.28-33.36,5.43-5.09,12.47-12.09,13.79-12.17,2.64.61,45.51,43.91,46.47,45.91S439.56,282.27,436.59,281.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.74,209.36s2.22,12.38,4.41,22.39c1.59,7.31,3.27,13.75,4.35,14.45s7.22,3.74,9.24,4.67c0,0,8.47,47.92,18,64.25,3.28,5.59,20.19,12.65,29.33,8,21.44-11,49.26-43.05,49.26-43.05l-26-28.54-28,27.5c-4.87-11.9-5.72-35-5.72-35s1-22.62-6.21-32.8Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.16,209.34S252.52,278,251.87,306.2c-.21,9.1,4.37,20.7,4.37,20.7s33.39,6.09,52.2-2.29,27-25.22,35.22-39.41c3.63-6.27,6.38-7.85,6.38-7.85s-6.38-29.07-6.48-32.31c0,0,1.57-21.2-7.11-33.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.07,121.81c-10.31,10.48-11.89,36.86,1.52,54.29,11.36,14.76,37,17,47.8,7.85,11.45-9.75,9.39-25.1.7-32.4-9-7.54-19.47-5.23-24.95-12-2.62-3.24-3.73-10.2-7.4-15.15C328.65,118.88,320.36,116.43,315.07,121.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.37,129.05a45.1,45.1,0,0,0,3.05,6.86,17.45,17.45,0,0,0,4.92,5.76,11.29,11.29,0,0,0,3.52,1.56c1.21.36,2.43.66,3.64,1a72.46,72.46,0,0,1,7.15,2.1,28.57,28.57,0,0,1,6.61,3.24A17.87,17.87,0,0,1,372,161.6a31.34,31.34,0,0,1,.38,7.44,29,29,0,0,0,.07-7.51,18.94,18.94,0,0,0-2.45-7.16,17.75,17.75,0,0,0-5.22-5.52,29.37,29.37,0,0,0-6.78-3.42,67.07,67.07,0,0,0-7.26-2.05c-1.21-.3-2.42-.59-3.61-.92a12.36,12.36,0,0,1-3.34-1.4,16.9,16.9,0,0,1-4.93-5.39A51.28,51.28,0,0,1,335.37,129.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.11,124.14a52.14,52.14,0,0,0-6.68,14.63,43.16,43.16,0,0,0-1.54,16.07,33.14,33.14,0,0,0,1.83,7.92,18.12,18.12,0,0,0,.75,1.89,19.35,19.35,0,0,0,.84,1.85c.32.6.62,1.21.95,1.8l1.09,1.72a41.77,41.77,0,0,0,11.44,11.28c-1-.87-2.09-1.68-3.08-2.58a39.78,39.78,0,0,1-2.85-2.81,38.08,38.08,0,0,1-4.91-6.28,34.19,34.19,0,0,1-5.13-14.89,43.59,43.59,0,0,1,1.3-15.78,58.23,58.23,0,0,1,2.5-7.6A56.42,56.42,0,0,1,313.11,124.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.66,165.16c-7.19,3.35-39,9.7-48.73,2.21-9.91-7.63-17.15-38.37-18.33-42.2-2.75-9,25.11-10.08,25.93-7.62,2.92,8.75,6.24,31.76,9.94,33,7.78,2.52,15.29,2.88,27.81,5.12C315,157.19,317.61,161.46,309.66,165.16Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.27,126.8c-1.29-2.88-6.19-16.76-6.65-20.88s-.94-16.07,2.18-16.75S242.34,92,242.34,92s.6-5.07,3.8-5.47,3.67,5.06,3.67,5.06,1-5.17,4.22-5.34,2.77,5.39,2.77,5.39.69-4.77,3.4-3.78c3.27,1.18,1,9.82,1.85,14.33.2,1,5.41,20.48,5.41,20.48Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.83,91.15c-1.65,6.36-1.27,9.43.7,15.6,0,.12-.13.2-.18.08-2.48-5.86-3.51-9.65-.82-15.78C256.66,90.75,256.91,90.84,256.83,91.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,91.06c-1.14,6.76-.75,10.1.83,16.7a.08.08,0,0,1-.16,0c-2.1-6.35-3-10.15-1-16.75C249.69,90.76,250,90.75,250,91.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.43,92.32c-.63,6.62-.37,10.29,2,16.51a.13.13,0,0,1-.23.1c-3-6.1-3.39-10.68-2-16.61C242.32,91.92,242.47,91.9,242.43,92.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,126.56s3.5-7.45,4.32-11.07-1.09-18.2-4.27-18c-4.1.3-4.65,8.94-4.37,13.21,0,0-9.49.69-11.23,6.8S268.79,126.56,268.79,126.56Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,98c-3.54,3-2.81,8.55-2.84,12.71a.38.38,0,0,1-.5.38c-4,.55-9.38,2.49-11.28,6.25a.1.1,0,0,1-.18-.08c1.49-4.31,6.66-6.64,11-7,0-4.27-.51-9.9,3.75-12.32C267.74,97.92,267.77,98,267.74,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,123.43s5.22,24.75,7.43,25.86c3.67,1.85,24.87,5.15,32.41,6.72s12.7,6.41-5.64,12.93c-17.72,6.3-37,9.89-46.52,6.3-11.56-4.37-22.08-30.93-22.08-30.93Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.68,150c13.66-9.06,28.49-17,31.05-18.49.13-.07.2.16.08.23-2.41,1.42-19.18,12.16-31.05,18.51C240.62,150.35,240.55,150.11,240.68,150Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.17,161.64c-.92,2.05-4.46,4.52-12.29,7.3-17.72,6.3-37,9.89-46.52,6.3a14.73,14.73,0,0,1-3.68-2.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.16,209.34l49.72,1.94s-2.29-34.64-9.74-48.92c-3.39-6.5-8.32-7-13.24-4.83-1.23.55-18,12.8-20.54,18-2.27,4.57.16,11,.16,11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,158s-7.25,8.35-7.77,11.68a37,37,0,0,0,0,8,134.89,134.89,0,0,0,12.34-5.6c4.1-2.33,6.9-14.24,6.9-14.24s5.89,5.57,8.39,16.82c1.94,8.68,6.32,35.27,6.65,36.05s7,17.18,6.14,33.92c0,0,4.84,20.62,7.16,22.94s6.21-.56,6.21-.56-13.37,46.29-38.69,54c-22.47,6.88-70.44-10.19-69.44-19.67s16.5-52.31,35.42-92l7.44-22.59s-3.25-6.62.16-11.77S309.74,159.19,312.4,158Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,274.71c-1.45,4.18-2.83,8.37-4.37,12.52-.78,2.09-1.48,4.22-2.17,6.35a27,27,0,0,0-1.43,6.71.07.07,0,0,1-.15,0,33.7,33.7,0,0,1,1-7.47,77.86,77.86,0,0,1,3.69-13.07c.84-2.09,1.79-4.15,2.79-6.18s2-4.09,3.09-6c.08-.14.34-.06.28.11C285,270,284,272.32,283.17,274.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.1,285.11c0-3,0-5.92.19-8.88.18-2.61.39-5.22.75-7.81s.92-5.21,1.52-7.79c1.19-5.15,2.56-10.28,4.06-15.35a0,0,0,0,1,0,0c-.83,2.85-1.59,5.72-2.19,8.63-1,5.14-1.58,10.33-2.34,15.51s-1.47,10.44-1.87,15.67C321.25,285.2,321.1,285.21,321.1,285.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.29,312.61c-.34.33-.68.64-1,.95-.6-.43-1.19-.87-1.77-1.31-5.11-3.9-10.69-8.38-12.94-14.61a26.62,26.62,0,0,1-1.15-9.35,81,81,0,0,1,.92-9.71c0-.12.22-.1.2,0a65.47,65.47,0,0,0-.4,10.66,22.29,22.29,0,0,0,2.54,8.84,31.48,31.48,0,0,0,5.6,7.23C327.8,307.91,330.53,310.27,333.29,312.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.84,269.63c-1.58,4.38-3.09,8.78-4.36,13.26q-.94,3.32-1.68,6.67c-.49,2.26-.85,4.54-1.26,6.81a51.41,51.41,0,0,0-.81,6.78c-.06,1.17-.06,2.34,0,3.51s-.07,2.27,0,3.41c0,.16-.23.16-.25,0-.11-.72-.3-1.41-.44-2.11a16.92,16.92,0,0,1-.19-1.87c-.11-1.29-.15-2.58-.17-3.86a61.64,61.64,0,0,1,.28-7.69,78.65,78.65,0,0,1,3-13.63c1.32-4.46,2.87-8.85,4.46-13.22,1.66-4.55,3.27-9.12,5.27-13.53s3.94-9.09,5.72-13.71c0-.11.21-.07.17,0-.91,2.58-1.72,5.2-2.61,7.78s-1.55,5.24-2.39,7.83c-.74,2.3-1.48,4.57-2.31,6.84S303.65,267.4,302.84,269.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.89,319.47l-1.54-.39A36.91,36.91,0,0,1,280.11,309a32.55,32.55,0,0,1,.19-3.95c.08-1.23.23-2.46.41-3.68a33,33,0,0,1,2-7.37c0-.09.18,0,.15.06a25.44,25.44,0,0,0-1.65,8,24,24,0,0,0,.1,3.6c.14,1.2.41,2.39.56,3.6a64.42,64.42,0,0,0,1.27,7.17C283.36,317.49,283.62,318.49,283.89,319.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.4,318a29.44,29.44,0,0,1-6.67,3,42.22,42.22,0,0,1-12,1.58c-.76-1.05-1.47-2.11-2.15-3.21a32,32,0,0,1-4.71-12.59c-.65-5.2.61-10.46,1.71-15.51,1.13-5.23,9.18-27.94,10.5-26.25,1.6,2.06-2.95,26.12-3.23,29a12.68,12.68,0,0,0,1.36,7.8,36.93,36.93,0,0,0,5.1,6.26q2.88,3.12,5.94,6.07C323.59,315.48,325,316.73,326.4,318Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.38,268.46a33.28,33.28,0,0,1-1.77,2.86c-1.62,2.45-3.26,4.89-4.89,7.32s-3.35,4.93-5,7.4c-1.37,2-2.61,4.13-4.72,5.48a.44.44,0,0,1-.61-.58c1.26-2.55,2.71-5,4.07-7.51a136.89,136.89,0,0,0,6.47-12.65,57.26,57.26,0,0,0,2.36-6.82c0-.09.05-.19.08-.28a13,13,0,0,0,1.85,3.87A3.1,3.1,0,0,0,354.38,268.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.19,207.71c-3.1,1.22-6.19,2.47-9.38,3.44a70.33,70.33,0,0,1-9.52,2.11,36.46,36.46,0,0,1-16.93-1,24.16,24.16,0,0,1-8.39-5.08c-.07-.06-.17,0-.1.12a23.14,23.14,0,0,0,15,7.94c6.42.84,12.66-.52,18.61-2.88,3.61-1.43,7.19-3,10.75-4.52C335.3,207.81,335.27,207.68,335.19,207.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.4,187.72a43.36,43.36,0,0,0-6.41-.8c-1.07,0-2.13,0-3.2,0-.53,0-1.06,0-1.6,0a7.14,7.14,0,0,1-1.66-.16s-.07.06,0,.07a11.83,11.83,0,0,0,1.52.42,11.32,11.32,0,0,0,1.53.15c1.08.05,2.17.05,3.26.09,2.18.07,4.37.15,6.55.38C310.47,187.9,310.5,187.74,310.4,187.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.94,191a46.74,46.74,0,0,0-5-1.75c-.85-.24-1.72-.43-2.59-.6l-1.25-.22c-.46-.07-.94-.09-1.39-.17-.05,0-.07.07,0,.08.44.09.85.25,1.28.36l1.28.34c.86.23,1.71.47,2.57.69,1.72.45,3.42.9,5.12,1.41A.07.07,0,1,0,314.94,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,169.9c11.47,16.4,29.24,40.79,39.77,40.57,9.53-.19,24.73-8.41,41.29-17.22,3.3-1.76-11.67-26.63-15-24.41-6.53,4.36-20.46,16-25,16.76-1.93.31-23.6-15.65-35.81-23.32C320.24,155.54,323.44,166.71,325.67,169.9Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.21,185.87c-4.63,3.82-19.33,9.81-22.73,9.64s-11.08-21.24-9.21-24.19,18.45-14.6,24.58-14.68S426,181.92,421.21,185.87Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.4,140.78s7.75-7.74,17.51-1.75c0,0,.42,29.11.69,30.87s8.21,34.28,8.21,34.28-7.35,5.19-18.73.95c0,0,1.84-33.36,1.65-34.34S398.4,140.78,398.4,140.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.81,204.18s-10.66-6-18.73.95C406.08,205.13,414.44,210,424.81,204.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.6,169.9c.23-.18,0-.28-.18-.32a4.1,4.1,0,0,0-.61-.11c-.42-.05-.84-.07-1.26-.08a23.42,23.42,0,0,0-2.52.07c-.84.06-1.68.16-2.51.29a7.78,7.78,0,0,0-1.2.29c-.35.12-.86.3-.59.75a.5.5,0,0,1-.23-.28.55.55,0,0,1,.08-.38,1.73,1.73,0,0,1,.51-.53,5.18,5.18,0,0,1,1.23-.6,10.89,10.89,0,0,1,2.63-.54,10,10,0,0,1,2.68.16,6.47,6.47,0,0,1,1.3.38,3,3,0,0,1,.61.33.71.71,0,0,1,.26.28.2.2,0,0,1,0,.21A.4.4,0,0,1,416.6,169.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.69,170.35c.22-.2,0-.27-.21-.31a4.2,4.2,0,0,0-.62-.06c-.43,0-.85,0-1.28,0-.85,0-1.69.12-2.52.25s-1.69.28-2.52.47a7.9,7.9,0,0,0-1.2.35,1.76,1.76,0,0,0-.53.27.31.31,0,0,0-.06.49.43.43,0,0,1-.24-.27.58.58,0,0,1,.08-.39,2,2,0,0,1,.5-.53,5.49,5.49,0,0,1,1.21-.66,12,12,0,0,1,2.6-.72,9.84,9.84,0,0,1,2.71,0,7,7,0,0,1,1.34.29,3.32,3.32,0,0,1,.64.29.76.76,0,0,1,.28.26A.22.22,0,0,1,416.69,170.35Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.77,170.71a.28.28,0,0,0,.09-.13s0,0,0,0a1.56,1.56,0,0,0-.3,0l-.62.12-1.25.26c-.83.18-1.67.32-2.5.47s-1.68.26-2.52.36c-.42.06-.84.11-1.25.19a2.74,2.74,0,0,0-.58.15c-.18.06-.29.2-.12.41a.36.36,0,0,1-.22-.28.47.47,0,0,1,.19-.35,2.63,2.63,0,0,1,.57-.39,8.57,8.57,0,0,1,1.24-.48,20.62,20.62,0,0,1,5.1-.86c.44,0,.87,0,1.31,0a5,5,0,0,1,.66.09,1.26,1.26,0,0,1,.34.12.32.32,0,0,1,.09.08.11.11,0,0,1,0,.13A.55.55,0,0,1,416.77,170.71Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.45,158.66c-1.05,3,3.09,2.53,3.09,2.53s-5.79,2.11-5.68,5.63,5.09,2.63,5.45,2.58c-.31.12-5.58,2.21-5.11,5.72.5,3.66,5.37,2,5.68,1.94-.25.2-3.57,2.89-2.6,5.48,1.66,4.46,10.34-2.18,14.13-1.51,0,0,1.43,4.95,1.46,5.14,0,0,6.55-4.54,7.17-9.71a3.32,3.32,0,0,0-2.15-3.56s2.92-1.68,2.63-4.46C428.37,167,426,166,426,166a4.17,4.17,0,0,0,1.87-3.91c-.32-2-2.69-2.69-2.69-2.69s1.55-2.4.57-4.3C423.74,151.24,406.72,152.24,404.45,158.66Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.78,159.21a0,0,0,0,0,0-.09,29.54,29.54,0,0,0-17.48,2.07c-.17.08-.11.39.1.34A60.69,60.69,0,0,1,424.78,159.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,165.94c.07,0,.07-.11,0-.12a27.7,27.7,0,0,0-18.93,3.44c-.19.12-.25.43,0,.3C411.07,167.46,420.53,165.79,426,165.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,177.45c5.6-3.24,11.67-4.36,18.08-4.61.08,0,.07-.12,0-.13-3.17-.73-7.23-.15-10.36.58a17,17,0,0,0-7.83,4C407.37,177.34,407.45,177.52,407.57,177.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.54,161.19a18.38,18.38,0,0,0-3.06,1.81,6.42,6.42,0,0,0-2.24,2.55,2.13,2.13,0,0,0-.06,1.53,3.22,3.22,0,0,0,.89,1.31,3.8,3.8,0,0,0,3,.65l2.57-.42-2.27,1.29a10.89,10.89,0,0,0-2.71,2.15,3.81,3.81,0,0,0-1.13,2.91,2.17,2.17,0,0,0,1.85,2,6.55,6.55,0,0,0,3.28-.4l2.91-1-2.4,1.92a10,10,0,0,0-1.78,1.84,4.16,4.16,0,0,0-.9,2.21,2,2,0,0,0,1,1.81,4.24,4.24,0,0,0,2.42.19,33.63,33.63,0,0,0,5.17-1.41c.86-.28,1.72-.55,2.6-.79a6.34,6.34,0,0,1,2.7-.29,6.93,6.93,0,0,0-2.62.53c-.85.3-1.69.64-2.53,1a28.82,28.82,0,0,1-5.2,1.72,5.11,5.11,0,0,1-2.91-.14,2.81,2.81,0,0,1-1.58-2.62,5,5,0,0,1,1.05-2.76,10.94,10.94,0,0,1,1.94-2.08l.51.88a7.51,7.51,0,0,1-3.86.52,3.17,3.17,0,0,1-1.88-1,3.58,3.58,0,0,1-.81-1.95,4.81,4.81,0,0,1,1.43-3.68,11.54,11.54,0,0,1,3-2.32l.3.87a4.55,4.55,0,0,1-3.7-1,3.9,3.9,0,0,1-1-1.67,2.72,2.72,0,0,1,.15-1.95,6.65,6.65,0,0,1,2.59-2.59A15.3,15.3,0,0,1,407.54,161.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.74,168.84s11.7-22.62,18.3-13.72c2,2.65,6.86,15.85,4.22,16.89-3.4,1.33-6.47-3.8-7.89-7.32,0,0-2.89,8.25-9.24,7.95A6.32,6.32,0,0,1,391.74,168.84Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.44,154.42a13.59,13.59,0,0,1,2.23,3.18,28.91,28.91,0,0,1,1.59,3.55,44.55,44.55,0,0,1,2.19,7.5,7.42,7.42,0,0,1,.11,2.07,2.85,2.85,0,0,1-.37,1.12,1.89,1.89,0,0,1-.42.5,1.91,1.91,0,0,1-.56.33,3.28,3.28,0,0,1-2.27,0,6.16,6.16,0,0,1-1.82-1.09,11.86,11.86,0,0,1-2.48-3.16,25.05,25.05,0,0,1-1.68-3.56l.84,0a15.09,15.09,0,0,1-1.35,2.66,13.74,13.74,0,0,1-1.81,2.35,9.94,9.94,0,0,1-2.34,1.8,7.49,7.49,0,0,1-2.77.92,8.52,8.52,0,0,0,2.6-1.18,10.05,10.05,0,0,0,2.09-1.92,14.44,14.44,0,0,0,1.6-2.34,15.33,15.33,0,0,0,1.13-2.57l.35-1.1.49,1.07a28.84,28.84,0,0,0,1.72,3.37,11.65,11.65,0,0,0,2.31,2.87,3.2,3.2,0,0,0,3,.91c.84-.26.8-1.67.63-2.87a37.93,37.93,0,0,0-.79-3.72c-.31-1.25-.64-2.48-1-3.7A24.51,24.51,0,0,0,409.44,154.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.43,171s-19.9,13.79-22.29,13.17c-4-1-29.57-19.4-36.29-23.19s-9,1.47-5.09,8.07c10.27,17.34,27.14,44.51,41.95,47.36,8,1.53,36-9,36-9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.61,186.15c-.33-.44-.53-1-.82-1.46l-.93-1.51q-.93-1.44-1.83-2.91c-1.21-1.94-2.53-3.81-3.8-5.71a0,0,0,1,0,0,0c1.11,2,2.19,4,3.44,6a.83.83,0,0,1,.08.12l-.8-.79-1.65-1.65s-.09,0-.06.06c.5.59,1,1.17,1.56,1.71.29.28.57.56.87.82l.41.36,1.41,2.16c.32.5.66,1,1,1.47s.78.9,1.07,1.4C335.55,186.29,335.67,186.22,335.61,186.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,177c6.24,14.14,11.17,29.1,12.19,31.73,0,.12-.18.15-.23,0-.94-2.46-8.24-19.74-12.22-31.73C382.73,176.87,383,176.85,383,177Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.85,154.38c6.8-1.49,18.63,3.44,19.5,8.57.73,4.39.85,37.37,1.82,46s27.38,45.13,27.38,45.13l-12.24-.8-2.12,11.2S326,232.55,321.44,217.6s3.69-57.24,2.44-59.38-6.41-1.85-8.75-1.42-6.05,5-7.93,9.55S298,200.23,297.89,211s14.36,51.56,14.36,51.56l-10.62-4.77-7.44,10.24s-11.12-39.75-11.58-57.33c-.29-11.18,8-31.3,17.11-44.72C304.94,158.34,310.76,155.27,314.85,154.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.33,158.87c-.45.85-6.37,5.59-10.47,4.29-1.34-.43.67-7.82.67-7.82l0-.58.33-8.12,10.53-3.37,1.51-.42s-.24,2.22-.56,5c0,.13,0,.26-.05.4s0,.3,0,.44c0,.42-.09.84-.14,1.25s-.08.63-.14,1-.09.65-.14,1A52.24,52.24,0,0,1,323.33,158.87Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,147.82a16.3,16.3,0,0,1-11.81,6.94l.33-8.12,10.53-3.37,1.51-.42S325.68,145.07,325.36,147.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5,129.39c-7.58,12.07-1.21,18,1.4,19.61,2.36,1.48,10.6,6.23,19.39-5s5.57-18.57.35-22.24S314.09,117.32,306.5,129.39Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.51,128.38c.31.14.62.21.94.32a1.61,1.61,0,0,0,1,.15.51.51,0,0,0,.31-.54,1.26,1.26,0,0,0-.91-.89,1.85,1.85,0,0,0-1.33,0A.54.54,0,0,0,309.51,128.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,133.37a9.2,9.2,0,0,1-.72-.67,1.6,1.6,0,0,1-.61-.82.49.49,0,0,1,.32-.53,1.25,1.25,0,0,1,1.21.38,1.85,1.85,0,0,1,.66,1.16A.54.54,0,0,1,317.92,133.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.18,135.21s0,.08,0,.12c-.54.8-1,1.81-.46,2.55,0,0,0,.07,0,.05C312.88,137.23,313.54,135.89,314.18,135.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.46,134.82c1.38.73-.18,3.44-1.47,2.76S314.3,134.2,315.46,134.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91,135.27c.15.29.22.69.49.89a1.17,1.17,0,0,0,1.1-.07s.05,0,0,.06a1.15,1.15,0,0,1-1.4.7,1.17,1.17,0,0,1-.48-1.49C315.68,135.25,315.85,135.15,315.91,135.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.61,132.34s-.08,0-.1,0c-.45.86-1.12,1.77-2,1.61,0,0-.05,0,0,0C308.46,134.44,309.32,133.23,309.61,132.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.36,131c-1.3-.87-2.95,1.79-1.75,2.6S310.45,131.76,309.36,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.7,130.86c-.3,0-.67.14-.93,0s-.34-.58-.36-1c0,0,0,0-.06,0a1.21,1.21,0,0,0-.06,1.54c.39.36,1,.13,1.43-.3C308.8,131.05,308.82,130.86,308.7,130.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.3,142.17a1.48,1.48,0,0,1-1,.13,2.58,2.58,0,0,1-.81-.7,0,0,0,0,0-.06,0,1.3,1.3,0,0,0,.85,1,1,1,0,0,0,1.07-.41S310.35,142.16,310.3,142.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.88,138.89a3.91,3.91,0,0,0,.62,1.91,1.76,1.76,0,0,0,.85.66c.77.27,1.18-.31,1.41-.9a4.12,4.12,0,0,0,.24-1A5.11,5.11,0,0,1,307.88,138.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,140.8a1.76,1.76,0,0,0,.85.66c.77.27,1.18-.31,1.41-.9A1.82,1.82,0,0,0,308.5,140.8Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.6,137.08s-.91,1.15-1.26,1.74c0,.05.09.16.29.29l0,0a3.27,3.27,0,0,0,3.33.56.07.07,0,0,0,0-.13,4.88,4.88,0,0,1-3-.78c.05-.19,1.62-1.91,1.53-2a6,6,0,0,0-1.51-.48c1.83-2.44,4-4.57,5.82-7,.06-.09-.06-.19-.13-.13a49.42,49.42,0,0,0-6.59,7.3C306.83,136.77,308.3,137,308.6,137.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.78,144.35c-1.34-.87-2.8-6.73.87-13.5,0,0-2.88,6.31-2.92,7.45s-.81-3.29,2.07-8.79a25.27,25.27,0,0,1-7.17-.25c-3-.73-4.51-1.63-4.59-1.92s4.35.65,6,0c0,0-8.58-.67-11.84-2.2-.38-.17,3.33-6.57,9.95-7s12.43,6,13.37,9.17c0,0,1.85,1.34,2.21,6.43C335.14,139.25,328.23,145.28,326.78,144.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.51,148.47a3.05,3.05,0,0,1-.66-.15,2.3,2.3,0,0,1-.61-.29,2.08,2.08,0,0,1-.61-.61,2.43,2.43,0,0,1-.28-.62,2.76,2.76,0,0,1-.12-1l2.44-3s4.8-2.53,6.09-.62S327,148.77,324.51,148.47Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.29,143.49s0,.07,0,.06a6.09,6.09,0,0,0-4.54,1.95,1.34,1.34,0,0,1,1.94.59s-.05.09-.09.06a1.48,1.48,0,0,0-1.68-.29,7.3,7.3,0,0,0-1.3.82c-.14.1-.34-.1-.21-.22l0,0C324.35,144.53,327.17,142.64,329.29,143.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.61,147.85a.66.66,0,1,1-.1-.93A.66.66,0,0,1,324.61,147.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.27,147.58a.46.46,0,0,1-.65.07.47.47,0,0,1,.58-.73A.46.46,0,0,1,326.27,147.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.46,142.69a7.26,7.26,0,0,1-2.34-.38,5.21,5.21,0,0,1-3.51-3.31c-.49-1.64.52-3.57,1.58-5.61,1.23-2.37,2.51-4.81,1.37-6.75-2.16-3.67-10.62-6.87-10.7-6.91l.26-.7c.36.14,8.8,3.33,11.08,7.23,1.35,2.29-.08,5-1.35,7.48-1,1.9-1.92,3.7-1.52,5a4.47,4.47,0,0,0,3,2.81,5.54,5.54,0,0,0,4.84-.43l.44.61A5.4,5.4,0,0,1,355.46,142.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.82,141.45a5.49,5.49,0,0,1,.69-2.57,19.36,19.36,0,0,1,3.08-3.26l.49.57a17.6,17.6,0,0,0-2.91,3.06,4.8,4.8,0,0,0-.6,2.19Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.49,142.22a16.84,16.84,0,0,1-2-.16l.11-.74a12.35,12.35,0,0,0,2.45.13,13.54,13.54,0,0,0,3.58-2.17l.46.59c-.29.22-2.87,2.21-4,2.32A6.19,6.19,0,0,1,360.49,142.22Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,141.75l-.64-.39a19.57,19.57,0,0,1,2.14-3l3-2.59.49.57s-2.38,2-3,2.59A19.06,19.06,0,0,0,358.65,141.75Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,142l-.28-.7a22,22,0,0,0,3.52-1.7c.62-.54,2.53-1.8,2.61-1.85l.42.62s-1.95,1.29-2.53,1.8A23.86,23.86,0,0,1,358.57,142Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.93 125.44 306.02 104.91 336.14 109.42 354.6 132.72 326.93 125.44",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.93 125.44 306.02 104.91 336.14 109.42 354.6 132.72 326.93 125.44",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,120.37l3.41-7.89s9.5.86,15.33,4.22S343,127,343,127l-5.07,7.7s-7.51-6.5-12.28-9.12A96.65,96.65,0,0,0,313,120.37Z",
    style: {
      fill: "#06EB83"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.26,395.3s0,40.11,0,40.14c0,7.67.06,14.4.44,17.87a.13.13,0,0,0,0,.06,5.37,5.37,0,0,0,.55,2.37l0,.05c2.27,1.56,63.56,3.66,65.72,3s.49-6.86-1.82-8.84-25.43-13.28-25.43-13.28l-.39-40.09Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.27,427.21v8.23c0,7.67.06,14.4.44,17.87a.13.13,0,0,0,0,.06,10.19,10.19,0,0,0,.55,2.37l0,.05c2.27,1.56,63.56,3.66,65.72,3s.49-6.86-1.82-8.84-25.43-13.28-25.43-13.28l.11-8.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.05,458.8c-2.17.65-63.45-1.45-65.74-3-.87-.58-1.09-9.53-1-20.35,0-.11,0-.22,0-.34l39.55.92,0,.67S212.89,448,215.22,450,219.21,458.16,217.05,458.8Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.43,456.4c-10.32-.61-52-2.08-62.26-1.9-.08,0-.08.06,0,.07,10.22.82,51.92,2,62.26,2C216.65,456.57,216.65,456.41,216.43,456.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.11,436.92c-4-.9-9-.45-12.24,2.34-.12.11,0,.29.17.25a57,57,0,0,1,12-2.08A.26.26,0,0,0,193.11,436.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,438.79c-4-.9-9-.45-12.23,2.34-.13.11,0,.29.16.25a57.17,57.17,0,0,1,12-2.08A.26.26,0,0,0,196,438.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.86,440.66c-4-.9-9-.45-12.24,2.34-.12.11,0,.29.16.25a57.17,57.17,0,0,1,12-2.08A.26.26,0,0,0,198.86,440.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.28 366.46 148.29 366.91 149.18 437.13 192.08 436.27 183.27 222.2 147.04 222.2 148.28 366.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.29,429.12c-6.7-.06-4.78-.14-11.48-.12-3.27,0-24.82.08-27.87.63a.07.07,0,0,0,0,.13c3.07.47,24.6,0,27.88-.05,6.7-.14,4.77-.18,11.47-.4A.1.1,0,0,0,190.29,429.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.46,405.31q-.14-9.63-.31-19.25-.37-19.24-.72-38.49-.7-38.29-1.23-76.59c-.22-14.4-.21-28.81-.58-43.2a0,0,0,0,0-.06,0c-.24,12.83-.09,25.67-.07,38.5s.07,25.67.2,38.5c.25,25.54.6,51.07,1.21,76.6.17,7.2.34,14.4.59,21.59s.41,14.41.91,21.6a.09.09,0,0,0,.18,0C156.7,418.15,156.54,411.72,156.46,405.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.03 222.63 147.98 331.94 177.03 222.2 147.04 222.2 147.03 222.63",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.44,375.24,62.73,408.9c-3.36,6.89-6.18,13-7.35,16.29a.14.14,0,0,0,0,.06,5.41,5.41,0,0,0-.53,2.38s0,0,0,.06c1.37,2.39,55.69,30.86,57.92,31.21s3.42-6,2.19-8.75-17.16-23-17.16-23l20.35-33.79Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.84,427.63a.13.13,0,0,0,0,.06c1.37,2.39,55.69,30.86,57.92,31.22s3.42-6,2.2-8.76-17.16-23-17.16-23l3.63-6c-8.88-4.73-25-13-35-18.19l-3.67,6c-3.36,6.9-6.19,13-7.35,16.29a.14.14,0,0,0,0,.06A5.19,5.19,0,0,0,54.84,427.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.77,458.9c-2.23-.35-56.54-28.82-57.92-31.21-.54-.91,3.15-9.06,7.88-18.79l.15-.3,35.25,18-.33.59s15.92,20.19,17.16,23S115,459.27,112.77,458.9Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.26,456.48c-9-5-46-24.43-55.28-28.71-.08,0-.1,0,0,.05,8.85,5.18,45.93,24.29,55.23,28.81C113.38,456.72,113.45,456.58,113.26,456.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.69,428.81c-3.25-2.56-7.94-4.32-12-3.2-.16.05-.1.27,0,.3a56.68,56.68,0,0,1,11.75,3.35A.26.26,0,0,0,100.69,428.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.47,431.74c-3.25-2.56-7.94-4.32-12-3.19-.16,0-.1.26,0,.29a56.68,56.68,0,0,1,11.75,3.35A.26.26,0,0,0,102.47,431.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.25,434.67c-3.25-2.56-7.94-4.32-12-3.19-.16,0-.1.26,0,.29A56.68,56.68,0,0,1,104,435.12.26.26,0,0,0,104.25,434.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,222.16v0c-.16.75-2.7,12.5-5.32,22.6-1.91,7.37-3.88,13.86-5,14.53-1.28.75-7.5,3.51-9.59,4.37,0,0-14,69.86-21.38,91.52-6.81,20-35,73.41-35,73.41L61.13,408s32-54.22,35.32-63.95c5.21-15.08,24.73-88.72,24.73-88.72s-.15-23.05,7.62-33.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.46,420.65c-5.85-3.27-4.13-2.41-10-5.61-2.88-1.57-21.81-11.85-24.75-12.84-.07,0-.12.08-.07.12,2.47,1.89,21.57,11.84,24.48,13.35,6,3.08,4.28,2.13,10.25,5.15A.1.1,0,0,0,101.46,420.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,248.87c1.12-.29,2.32-.38,3.46-.56.93-.15,1.85-.31,2.76-.51a11.92,11.92,0,0,0,4.86-2.05,11.54,11.54,0,0,0,3.16-4.9c.45-1.06.92-2.12,1.39-3.18l.7-1.53a18.32,18.32,0,0,0,.87-1.85.07.07,0,0,1,.14.05,11.79,11.79,0,0,0-.39,1.32c-.16.52-.3,1-.46,1.55-.29.91-.56,1.83-.87,2.74a21.27,21.27,0,0,1-2,4.82c-1.69,2.69-4.71,3.77-7.73,4.16-.86.11-1.73.17-2.61.22a19.14,19.14,0,0,1-3.3,0A.15.15,0,0,1,131.68,248.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36,257.68a82.12,82.12,0,0,0-12.83,6,.15.15,0,0,0,.12.27c4.32-1.86,8.73-3.64,12.94-5.73A.28.28,0,0,0,171.36,257.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.66,228.08c0-.15-.28-.18-.27,0,0,5.13-.3,9.64-.73,14.44-.2,2.22-2,14.52-5.85,13.63-.65-.15-1-.79-1.08-1.76a15.37,15.37,0,0,1,.52-3.78c.42-2.57.77-5.15,1-7.75a70.75,70.75,0,0,0-.16-14.55.13.13,0,0,0-.25,0,133.61,133.61,0,0,1-1.17,20.09c-.48,3.19-2.1,8,1.25,8.5s5.61-7.56,6-9.77A74,74,0,0,0,172.66,228.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,256.46a18.64,18.64,0,0,0-.86,2.55,5.8,5.8,0,0,0-.37,2.09.15.15,0,0,0,.27.06,7.33,7.33,0,0,0,.9-2c.29-.79.6-1.57.87-2.37A.43.43,0,0,0,165.91,256.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.18,401.16C78,390.2,84,379.33,90,368.47c3-5.35,6.07-10.64,8.91-16.06a97.26,97.26,0,0,0,6.47-16.76q5.42-17.56,10.24-35.3t9.08-35.63c.71-3,1.49-6,2.06-9a27.53,27.53,0,0,0,0-9.19,29.17,29.17,0,0,1-.07-8.55,56.17,56.17,0,0,1,2-8.36c.45-1.44.94-2.87,1.44-4.29.05-.16.3-.09.25.07-1.77,5.78-3.57,11.61-3.19,17.73.18,2.94,1,5.82.91,8.78a42.06,42.06,0,0,1-1.49,8.68q-4.17,18-9,35.83T107.55,332c-1.74,5.73-3.36,11.55-5.83,17s-5.59,10.65-8.53,15.89c-6.08,10.81-12.21,21.6-18.48,32.3l-2.4,4.07C72.26,401.33,72.13,401.25,72.18,401.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.42,176.19c7.39,3.31,39.94,9.32,49.75,1.54,10-7.93,16.5-41,17.25-44.91s-24.71-10-25.58-6.45c-2.22,9.15-6.05,33.13-9.81,34.41-7.9,2.68-15.56,3.16-28.3,5.63C149.85,168.13,147.26,172.53,155.42,176.19Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,133.64c1.53-2.76,7.61-16.17,8.43-20.23s2.32-15.93-.73-16.87S225.93,99,225.93,99s-.16-5.11-3.31-5.77-4.1,4.71-4.1,4.71-.55-5.24-3.74-5.68-3.24,5.13-3.24,5.13-.27-4.81-3-4.06c-3.35.89-1.85,9.7-3.09,14.12-.28,1-7.15,19.93-7.15,19.93Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.56,97c1.09,6.48.45,9.5-2.05,15.48a.1.1,0,0,0,.18.09c3-5.62,4.33-9.3,2.18-15.64C211.76,96.57,211.51,96.64,211.56,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.42,97.46c.55,6.83-.12,10.12-2.27,16.57,0,.09.12.15.15.06,2.65-6.15,3.92-9.85,2.47-16.61C218.71,97.18,218.4,97.15,218.42,97.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.81,99.36c.05,6.65-.53,10.29-3.42,16.28a.12.12,0,0,0,.21.12c3.55-5.82,4.3-10.35,3.41-16.38C226,99,225.8,98.94,225.81,99.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.58,131.19s-2.85-7.73-3.35-11.4,2.67-18,5.81-17.54c4.06.66,3.87,9.32,3.22,13.54,0,0,9.39,1.51,10.59,7.76S196.58,131.19,196.58,131.19Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.1,102.8c3.27,3.27,2.06,8.76,1.73,12.91a.38.38,0,0,0,.47.42c3.89.89,9.12,3.29,10.7,7.2a.09.09,0,0,0,.18-.06c-1.12-4.42-6.06-7.19-10.39-7.9.4-4.25,1.37-9.81-2.66-12.6C200.1,102.75,200.08,102.78,200.1,102.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.26,132.46s-5.64,25.9-7.87,27.07c-3.72,1.94-25.3,5.62-33,7.34s-13.68,10.06,6,13.11,37.56,7.8,47,3.53c5.87-2.66,24.25-29.49,24.25-29.49Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.58,141.62c14.4,7.83,28.32,17.23,30.87,18.78.13.08,0,.25-.16.17-2.39-1.46-19.73-11.25-30.9-18.77C194.26,141.72,194.44,141.54,194.58,141.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.23,184.74c-10,1.83-25.8-2.11-42.87-4.76-12-1.87-14.42-5.71-12.74-8.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,238.81c.17.13,63.83-4.31,64.27-5,.24-.38-.6-9.05-3.87-19.42-5.43-17.28-17-40.58-24.73-47.76-3.09-2.87-11.68-1.63-15.06,2.12C131.57,179.84,120.39,238.32,121,238.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25,169.14s5.25,9.51,6.9,12c3.84,5.8,13,14,13,14a106,106,0,0,0,.5-18.74c-.21-2.34-3.05-9.38-3.05-9.38s17.35,18.3,26.55,55.12S206.28,365.6,206.28,365.6s-22.58,18.22-46.16,18.16C122,383.65,82.39,358.1,82.39,358.1s13.12-21.67,14.06-24.5,20.44-78.37,20.66-79S130.77,180.29,140.25,169.14Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.75,349.58c-.95,4.73-6.73,22.86-10.35,34.09a113.94,113.94,0,0,1-21.67-3.24c6.89-8.55,19.25-27.68,21.12-32.51,2.19-5.66,4.17-32.69,7.33-35.3S168.15,342.6,166.75,349.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.82,294c0-.19-.33-.25-.35,0-.19,1.59-.24,3.2-.4,4.79s-.45,3.19-.67,4.79c-.43,3.24-.92,6.48-1.38,9.71-.92,6.42-2.15,12.82-3.5,19.16-.76,3.58-1.73,7.15-2.8,10.65,0,.1.12.13.15,0a187.24,187.24,0,0,0,6.07-18.76,91.4,91.4,0,0,0,1.84-9.55,95.34,95.34,0,0,0,1-9.68c.09-1.81.05-3.62.05-5.43S158.94,295.87,158.82,294Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.16,367.36c0,1.33-.13,2.65-.23,4l-1.27.77c0-.1,0-.21,0-.31-.09-2-.14-3.91-.2-5.87-.22-6.86-.46-13.71-1.08-20.55-.16-1.71-.21-3.42-.37-5.13a41.59,41.59,0,0,1-.31-5.23,33.61,33.61,0,0,0-.49-5.1c-.21-1.74-.47-3.47-.69-5.2a.08.08,0,0,1,.15,0c.44,1.91.79,3.83,1.16,5.75.18,1,.34,1.92.53,2.88s.47,1.88.65,2.83a135.51,135.51,0,0,1,2.1,20.79C198.22,360.41,198.27,363.88,198.16,367.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.05,333.22c-.08-2.52-.16-5.06-.31-7.58s-.36-5-.63-7.45-.72-5-.94-7.57c-.25-2.85-.52-5.71-.73-8.57,0-.14-.23-.13-.22,0,.13,2.53.23,5.05.35,7.58s0,5.06.14,7.59c.19,5,.68,10,1.3,15,.36,2.86.89,5.69,1.14,8.56,0,.1.17.09.16,0C191.1,338.29,191.13,335.75,191.05,333.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,350.43c-1.66,3-3.4,6-5.16,9-1.57,2.65-3.11,5.32-4.93,7.81s-3.65,4.77-5.58,7.08c-1.36,1.62-2.73,3.24-4.16,4.79l-1.26-.36,1.26-1.53c3.52-4.24,6.75-8.7,10.09-13.08,1.71-2.24,3.47-4.43,5.07-6.76s3.1-4.65,4.56-7A.06.06,0,0,1,149.62,350.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.21,306.48c-2.32,7.18-4.67,14.33-7.46,21.34-1.37,3.44-3,6.76-4.54,10.13s-3,6.75-4.78,10a103.31,103.31,0,0,1-6.65,10.63c0,.08.07.16.13.1a91.23,91.23,0,0,0,12-18.74,101.51,101.51,0,0,0,4.11-10.5c1.27-3.54,2.43-7.11,3.57-10.69,1.29-4.07,2.51-8.15,3.74-12.23A.07.07,0,0,0,142.21,306.48Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.12,230.63c-.79.8-1.68,1.5-2.5,2.26L181.45,234c-.44.4-.91.7-1.37,1.07-1.67,1.35-3.39,2.63-5.08,4a43.79,43.79,0,0,1-10.92,6.43c-8.71,3.41-18.26,2.62-27.15.53-5.22-1.23-10.31-3-15.45-4.56-.07,0-.12.11,0,.14,4.48,2,9,3.71,13.67,5.21a56.61,56.61,0,0,0,14.09,2.9,36.54,36.54,0,0,0,14-1.8,43,43,0,0,0,11.45-6.16,38.75,38.75,0,0,0,5.59-5c.88-.95,1.72-1.94,2.59-2.89s1.64-2,2.5-3C185.42,230.69,185.24,230.51,185.12,230.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.3,180c-18.29-9.09-39-22.26-40.09-33-1-9.66,5.41-26.09,12.25-44,1.36-3.55,28.42,8.47,26.6,12.11-3.6,7.17-13.66,22.74-13.82,27.39-.07,2,16.35,18.72,25.57,30.19C152,186.71,137.59,183.65,130.3,180Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,87.51c-3.28,5.17-7.5,20.81-6.9,24.23s22.9,8.54,25.66,6.28,12.45-20.53,11.77-26.74S111.5,82.15,108.1,87.51Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,83.22s8,7.5,2.29,17.45c0,0-29.07,1.32-30.83,1.65s-34,9.27-34,9.27-5.41-7.19-1.53-18.7c0,0,33.41.81,34.38.58S153.74,83.22,153.74,83.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.19,111.59s5.71-10.85-1.53-18.7C89.66,92.89,85,101.4,91.19,111.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,102.32c.19.22.28,0,.32-.2a5.58,5.58,0,0,0,.09-.61c0-.42,0-.84,0-1.26a23.35,23.35,0,0,0-.15-2.52c-.09-.83-.21-1.67-.37-2.49a7.84,7.84,0,0,0-.32-1.2c-.14-.34-.33-.84-.77-.57a.52.52,0,0,1,.27-.23.59.59,0,0,1,.39.07,1.56,1.56,0,0,1,.53.49,4.74,4.74,0,0,1,.65,1.21,10.84,10.84,0,0,1,.61,2.62,9.63,9.63,0,0,1-.07,2.68,6.83,6.83,0,0,1-.34,1.31,3,3,0,0,1-.31.62.73.73,0,0,1-.28.27.18.18,0,0,1-.21,0A.71.71,0,0,1,125.2,102.32Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.75,102.42c.21.21.28,0,.31-.22a4.26,4.26,0,0,0,0-.63c0-.42,0-.85,0-1.27a23.46,23.46,0,0,0-.33-2.52c-.15-.83-.33-1.67-.54-2.49a9.35,9.35,0,0,0-.39-1.2,2.18,2.18,0,0,0-.29-.52.31.31,0,0,0-.49,0,.4.4,0,0,1,.26-.25.64.64,0,0,1,.39.07,2.17,2.17,0,0,1,.55.49,5.92,5.92,0,0,1,.7,1.18,11.83,11.83,0,0,1,.79,2.58,9.87,9.87,0,0,1,.13,2.71,6.88,6.88,0,0,1-.25,1.34,3.27,3.27,0,0,1-.26.65.88.88,0,0,1-.26.29C124.89,102.68,124.77,102.51,124.75,102.42Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.4,102.51a.28.28,0,0,0,.13.09s0,0,0,0a1.59,1.59,0,0,0,0-.29c0-.21-.09-.41-.14-.62l-.3-1.24c-.2-.82-.37-1.66-.55-2.49s-.3-1.67-.44-2.5c-.07-.42-.13-.84-.22-1.24a3.54,3.54,0,0,0-.17-.58c-.07-.18-.21-.28-.41-.1a.35.35,0,0,1,.27-.24.54.54,0,0,1,.36.18,2.62,2.62,0,0,1,.4.56,8.59,8.59,0,0,1,.52,1.22,19,19,0,0,1,.67,2.51,18.46,18.46,0,0,1,.35,2.57,11.43,11.43,0,0,1,0,1.31c0,.22,0,.44-.07.66a1.67,1.67,0,0,1-.11.34.17.17,0,0,1-.08.09.1.1,0,0,1-.13,0A.55.55,0,0,1,124.4,102.51Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.76,101.05c-2.9,1.44-2.94-2.81-2.94-2.81s-1.42,6.13-5,6.46-3.31-4.82-3.3-5.19c-.08.32-1.53,5.93-5.15,5.89s-2.75-5.17-2.68-5.51c-.17.29-2.47,4-5.22,3.33-4.72-1.12.91-10.74-.24-14.5,0,0-5.2-.83-5.4-.83,0,0,3.78-7.21,8.93-8.48a3.38,3.38,0,0,1,3.87,1.73S122,78,124.83,77.9c1.47,0,2.82,2.29,2.82,2.29a4.24,4.24,0,0,1,3.71-2.39c2,.08,3.07,2.39,3.07,2.39s2.24-1.87,4.28-1.12C142.85,80.58,144,98,137.76,101.05Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65,80.53a0,0,0,0,1,.09,0,30.3,30.3,0,0,1,.11,18c-.07.18-.39.16-.36,0A62.35,62.35,0,0,0,134.65,80.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,80.11c0-.07.1-.09.12,0a28.26,28.26,0,0,1-1.1,19.6c-.1.21-.4.3-.31,0C128,95.45,128.52,85.67,127.68,80.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.34,100.26c2.58-6.08,3-12.37,2.39-18.89,0-.08.12-.08.14,0,1.14,3.11,1.06,7.3.72,10.55a17.37,17.37,0,0,1-3,8.44C118.49,100.45,118.29,100.39,118.34,100.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.82,98.24a19.73,19.73,0,0,1-1.45,3.33,6.66,6.66,0,0,1-2.3,2.59,2.17,2.17,0,0,1-1.55.25,3.22,3.22,0,0,1-1.43-.74,3.88,3.88,0,0,1-1-3l.11-2.66-1,2.46a10.7,10.7,0,0,1-1.83,3,3.9,3.9,0,0,1-2.8,1.51,2.22,2.22,0,0,1-2.28-1.62,6.63,6.63,0,0,1,0-3.37l.68-3.08-1.65,2.67a10,10,0,0,1-1.63,2,4.21,4.21,0,0,1-2.13,1.18,2,2,0,0,1-2-.78,4.52,4.52,0,0,1-.5-2.43,36.36,36.36,0,0,1,.78-5.41c.18-.9.35-1.81.48-2.73a6.63,6.63,0,0,0,0-2.77,7.35,7.35,0,0,1-.21,2.72c-.2.9-.44,1.79-.68,2.68a30,30,0,0,0-1.09,5.48,5.28,5.28,0,0,0,.51,2.93,2.84,2.84,0,0,0,2.85,1.27,5.15,5.15,0,0,0,2.67-1.4,11.48,11.48,0,0,0,1.86-2.24l-1-.4a7.67,7.67,0,0,0,0,4,3.29,3.29,0,0,0,1.27,1.77,3.75,3.75,0,0,0,2.08.58,4.92,4.92,0,0,0,3.55-1.92,11.6,11.6,0,0,0,2-3.34l-.91-.2a4.63,4.63,0,0,0,1.49,3.62,4,4,0,0,0,1.81.82,2.85,2.85,0,0,0,2-.41,6.8,6.8,0,0,0,2.3-3A16.46,16.46,0,0,0,134.82,98.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.06,115.2S150.49,100.51,140.64,95c-2.92-1.66-16.91-5-17.63-2.16-.92,3.62,4.66,6.08,8.41,7.07,0,0-8,4-6.89,10.36A6.45,6.45,0,0,0,129.06,115.2Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.43,95.46a13.33,13.33,0,0,0-3.5-1.85,29.77,29.77,0,0,0-3.8-1.17,45.8,45.8,0,0,0-7.87-1.27,7.6,7.6,0,0,0-2.1.15,3,3,0,0,0-1.1.51,2.4,2.4,0,0,0-.45.49,2.29,2.29,0,0,0-.26.61,3.35,3.35,0,0,0,.28,2.3A6.47,6.47,0,0,0,124,96.94a12.07,12.07,0,0,0,3.51,2.11,28,28,0,0,0,3.82,1.26l-.08-.86a15.76,15.76,0,0,0-2.53,1.7,13.9,13.9,0,0,0-2.14,2.13,9.72,9.72,0,0,0-1.53,2.6,7.57,7.57,0,0,0-.58,2.92,8.41,8.41,0,0,1,.87-2.79,10.59,10.59,0,0,1,1.68-2.35,14.61,14.61,0,0,1,2.16-1.92,15.11,15.11,0,0,1,2.47-1.46l1.07-.5-1.15-.36a29.73,29.73,0,0,1-3.64-1.32,12,12,0,0,1-3.19-2,3.28,3.28,0,0,1-1.3-2.92c.16-.88,1.6-1,2.83-1s2.57.18,3.87.33,2.59.33,3.87.57A25.28,25.28,0,0,1,141.43,95.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.27,118.83s-11.46,21.88-10.53,24.23c1.54,3.9,20.82,24.37,25.5,30.69S149.84,188,132,184.29c-12.76-2.67-41.95-19.8-46.57-30.87-3.19-7.65-2.31-38.74-2.31-38.74Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,122.63c16.38.57,33,2.76,36,3,.14,0,.06.24-.08.23-2.79-.24-22.67-1.24-36-3C85.81,122.86,85.89,122.63,86.05,122.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.71,162.77c-7,0-17.3,11.57-16.86,14.65.65,4.4,7.26,36.67,8.17,45.29s-17,50-17,50l11.77-3.43,4.49,10.48s15.75-36.19,17-51.76-16-55.09-15.22-57.46,5.53-5.24,7.91-5.33,7,3.75,9.88,7.81,16.61,32.93,19,43.47S176,269.92,176,269.92l9.33-6.95,9.48,8.39s2.26-41.22-1.1-58.47c-2.13-11-14.8-30.7-26.63-41.83C160.31,164.7,153.9,162.76,149.71,162.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.34,176.82c-2.56.62-8.87-3.15-11.76-6.81-.19-.25-.26-3.24-.52-6.86-.16-2.2-.39-4.64-.77-6.85l14.46,1a36,36,0,0,0,.09,8.73,5.48,5.48,0,0,0,.25.89s0,.09,0,.15C157.71,168.77,159.34,175.85,155.34,176.82Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.09,166.94a1.31,1.31,0,0,1,0,.15,10,10,0,0,1-1.42.32c-7.92,1.15-11.48-8.14-12.38-11l13.41.95a36,36,0,0,0,.09,8.73A5.78,5.78,0,0,0,157.09,166.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.16,128.22s5.27.86,7.3,5.54,2.12,10.06,1.75,10.41S152.16,128.22,152.16,128.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88,139.68c-.21,5.21,6,18.5,10.26,20.7,6.16,3.21,14.42,1.5,16.69-5.49C165,148.11,156.62,131,152,129.13,145.29,126.44,136.19,132,135.88,139.68Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.54,142.52c.35-.27.63-.58,1-.89a2.15,2.15,0,0,0,.81-1.09.69.69,0,0,0-.42-.71,1.67,1.67,0,0,0-1.62.51,2.43,2.43,0,0,0-.88,1.53A.72.72,0,0,0,147.54,142.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.47,138.66a11.16,11.16,0,0,1-1.29.2,2.11,2.11,0,0,1-1.36-.05.66.66,0,0,1-.29-.77,1.67,1.67,0,0,1,1.4-.95,2.47,2.47,0,0,1,1.75.27A.72.72,0,0,1,156.47,138.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.71,152.79a1.47,1.47,0,0,0,1,.2,2.61,2.61,0,0,0,.87-.65s.07,0,.06,0a1.33,1.33,0,0,1-.94,1,1,1,0,0,1-1.06-.49A.06.06,0,0,1,152.71,152.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5,149.66a3.36,3.36,0,0,0,2.65.49,4.05,4.05,0,0,0,1.14-.43l.2-.11.18-.12a.25.25,0,0,0,.1-.28h0a.36.36,0,0,0,0-.09h0l0-.08c-.28-.71-.81-1.74-.81-1.74.31,0,1.86,0,1.69-.31a50.82,50.82,0,0,0-5.22-8.84.09.09,0,0,0-.16.1c1.31,2.88,3.12,5.52,4.48,8.39a6.08,6.08,0,0,0-1.65.19c-.08.07,1.05,2,1.15,2.31a0,0,0,0,1,0,0,4.62,4.62,0,0,1-3.62.38C152.46,149.52,152.41,149.61,152.5,149.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.72,149.55a3.94,3.94,0,0,1-1,1.76,1.78,1.78,0,0,1-1,.5c-.81.12-1.11-.54-1.22-1.17a3.92,3.92,0,0,1-.05-1A5.15,5.15,0,0,0,155.72,149.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.74,151.31a1.78,1.78,0,0,1-1,.5c-.81.12-1.11-.54-1.22-1.17A1.86,1.86,0,0,1,154.74,151.31Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62,144.73a1.56,1.56,0,0,1,.07-.79,1.1,1.1,0,0,1,.61-.59,1,1,0,0,1,.86.12,1.77,1.77,0,0,1,.51.59,3.25,3.25,0,0,1,.18.43,1.94,1.94,0,0,1,.12.95,2.87,2.87,0,0,0-.27-.65,3.2,3.2,0,0,0-.34-.53c-.26-.35-.6-.59-.9-.46s-.48.46-.47.9a7.27,7.27,0,0,0,.2,1.33A3.12,3.12,0,0,1,148.62,144.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,140.69a1.37,1.37,0,0,0-.61-.49,1.05,1.05,0,0,0-.85,0,1,1,0,0,0-.51.7,2,2,0,0,0,.07.78c0,.15.12.29.18.43a2.09,2.09,0,0,0,.61.74,3,3,0,0,1-.28-.64,3.5,3.5,0,0,1-.15-.62c-.07-.42,0-.84.3-1a.83.83,0,0,1,1,.28,7.54,7.54,0,0,1,.82,1.07A3,3,0,0,0,157.39,140.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,151.37c1.73-.25,1.3-5.62,1-7.6-.3-1.74-2.12-6.85-2.21-7.22s8.63,1.18,11.91-1.74,4.19-7.55,3.48-9.17S147.18,122.23,143,124s-7.24,9.57-7.24,9.57a21.27,21.27,0,0,0,.66-3.29c-.15-.16-2.29,2.16-1.88,4.27,0,0-.6-2.61-.82-2.56s-1.31,3-.12,4.36c0,0-1.39,3.19-.54,5.55S138.37,151.67,140.4,151.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,132.72a13.9,13.9,0,0,1-3,3A9.47,9.47,0,0,1,146,137a14.31,14.31,0,0,1-4.61-.42c-1.32-.33-2.62-.87-4-1.08-.33-.05-.45.45-.19.61a15.14,15.14,0,0,0,9.32,1.79,8.69,8.69,0,0,0,6.87-5.17A0,0,0,0,0,153.38,132.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.85,150.26s-4.42-3.59-6.13-1.89,2.48,7.53,5.13,7.74a2.52,2.52,0,0,0,2.88-2.23Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,150s0,.06,0,.07c1.87.2,3.19,1.5,4.27,2.94a1.4,1.4,0,0,0-2.12.2s0,.1.08.08a1.55,1.55,0,0,1,1.79,0,8.18,8.18,0,0,1,1.17,1.11c.12.13.36,0,.26-.19l0,0C141.83,152.09,139.32,149.57,137,150Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.21,166.67l-3.09,8.65-11-10.37-2.86,3.58s11,16.73,11.05,15.95l3.23-7.48,5.27,4.92-.91-12.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.71,175.56c-.22-2.12-.38-4.25-.7-6.35,0-.07-.13-.1-.15,0-.34,2.06.54,10.13.61,12.07l0,0c-.22-.22-4.88-4.32-4.92-4.25-.71,1.2-3.09,6.65-3.24,7.14-1.75-2.66-8.41-12.31-10.45-14.81a.07.07,0,0,0-.12.08c1.56,2.82,10.38,15.82,10.51,15.78a82.06,82.06,0,0,0,3.37-7.91c.8.9,5.51,5.55,5.52,5.24A67.35,67.35,0,0,0,159.71,175.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hat--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.09,61.23a5.45,5.45,0,0,1-3.8-1.73,6.36,6.36,0,0,1-2-5.18l.74.13A5.6,5.6,0,0,0,158.82,59a4.52,4.52,0,0,0,3.87,1.46c1.5-.26,2.86-1.66,4.3-3.13,1.73-1.77,3.52-3.61,5.95-4,4.68-.84,10.85,5.45,11.11,5.72l-.54.52c-.06-.06-6.15-6.29-10.44-5.5-2.19.39-3.89,2.13-5.54,3.82s-3,3-4.71,3.35A4.49,4.49,0,0,1,162.09,61.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,54.91l-.32-.68a4.8,4.8,0,0,0,1.7-1.5,18,18,0,0,0,1.43-4l.73.18a18.52,18.52,0,0,1-1.54,4.2A5.37,5.37,0,0,1,157,54.91Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13,54.58a11.93,11.93,0,0,1-1.3-2.3c-.39-1,.24-4.22.31-4.58l.74.15a13.35,13.35,0,0,0-.35,4.17,12.06,12.06,0,0,0,1.21,2.13Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,54.7l-.64-.4a18.57,18.57,0,0,0,1.62-3l1-3.86.73.18s-.76,3-1,3.87A19.1,19.1,0,0,1,157,54.7Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.14,54.48a24.59,24.59,0,0,1,0-4.16c.2-.74.48-3,.48-3.06l.75.09c0,.09-.29,2.37-.5,3.16a22.68,22.68,0,0,0,0,3.91Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.78 62.9 225.69 47.46 195.31 45.25 172.19 63.93 200.78 62.9",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.78 62.9 225.69 47.46 195.31 45.25 172.19 63.93 200.78 62.9",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.46,61l-1.59-8.44s-9.46-1.24-15.88.75-13.28,7.6-13.28,7.6L188,69.53s8.76-4.69,14-6.19A97.55,97.55,0,0,1,215.46,61Z",
    style: {
      fill: "#06EB83"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/Graduation.40d2b40eb85dccdcb8f16bcdbc8c7c78.svg";
export { ForwardRef as ReactComponent };